import { mainApiAxios as axios } from '@/plugins/axios'

export default {

    listThemeColors() {
        return axios.get('systemSettings/theme-colors')
    },

    updateTheme(themeColors) {
        return axios.post('systemSettings/update/theme-colors', themeColors)
    },

    updateSettings(setting) {
        return axios.post('systemSettings/update/setting', setting)
    },

    listAll() {
        return axios.get('systemSettings')
    },
    getSurveyAttendancePerUser() {
        return axios.get('systemSettings/survey-attendance-per-user')
    },
    getSurveyAvgTime() {
        return axios.get('systemSettings/question-avg-time')
    },
    isShowAddNewUser() {
        return axios.get('systemSettings/isShowAddNewUser')
    }

}